export function getComponentRefAutoLinkMode({ currentComponentRef, nextComponentRef, hasLoadedComponentTask }) {
    if (!nextComponentRef) return "sync-now"
    if (currentComponentRef && nextComponentRef === currentComponentRef) {
        if (hasLoadedComponentTask) return "auto-link-now"
        return "wait-for-effect"
    }
    return "clear-and-wait"
}
